import axiosInstance from "../utils/axiosConfig";

export const usePhotoUpload = (selectedSchedule, setSelectedSchedule) => {
  const handlePhotoUpload = async (files, onUploadProgress) => {
    const formData = new FormData();
    Array.from(files).forEach((file) => {
      formData.append("schedule[photos][]", file);
    });
    const response = await axiosInstance.patch(
      `/schedules/${selectedSchedule.id}`,
      formData,
      { onUploadProgress }
    );
    const updatedSchedule = response.data;
    setSelectedSchedule(updatedSchedule); // Actualiza el estado con las nuevas fotos
  };

  return { handlePhotoUpload };
};
